export default "__VITE_ASSET__CmSk0iJt__"